import { normalize } from 'normalizr';
import { addEntities } from '../actions';
import { CALL_API } from '../../middleware/api';
import { meta } from '../../schema';


const LOAD = 'meta/LOAD';
const LOAD_SUCESS = 'meta/LOAD_SUCESS';
const LOAD_FAIL = 'meta/LOAD_FAIL';

export const loadMeta = () => (dispatch) => {
  return dispatch({
    [CALL_API]: {
      types: [LOAD, LOAD_SUCESS, LOAD_FAIL],
      endpoint: 'meta/',
      method: 'GET',
    }
  }).then(({ response })  => {
    const { entities: { meta: _, ...entities} } = normalize(response.results, meta);
    dispatch(addEntities(entities));
  });
}


// WEBPACK FOOTER //
// ./src/redux/modules/meta.js